<template>
    <b-container>
        <b-row class="justify-content-center">

            <loading v-if="loading || isRequestSending" />

            <b-card bg-variant="light w-75 mt-3" v-if="!loading && !isRequestSending && getSolveNonDeliveryPostStatus === ''">

                <b-form @submit.prevent="send">

                    <label for="topicId"><b-icon-check-circle class="mr-2" />{{$t('Solution')}}:</label>
                    <b-form-select id="topicId"
                                   v-model="topicId"
                                   :options="getNonDeliverySolution"
                                   :plain="true"
                                   :state="topicId > -1"
                                   required>
                    </b-form-select>

                    <div class="justify-content-center mt-2">
                        <b-button to="/">{{$t('Back')}}</b-button>
                        <b-button type="submit" variant="success" class="ml-2">{{$t('Send')}}</b-button>
                    </div>
                </b-form>
            </b-card>
        </b-row>


    </b-container>
</template>

<style>
    .home {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
</style>

<script>
    import { mapGetters } from "vuex";
    import { SOLVENONDELIVERY_REQUEST, CLEARSOLVENONDELIVERYSTATUS } from "actions/nonDelivery";

    export default {
        name: "SolveNonDelivery",
        data() {
            return {
                order: this.$store.getters.getOrderById(this.$attrs.id),
                topicId: -1,
                nonDeliveryBody: "",
                TripLineId: this.$store.getters.getOrderById(this.$attrs.id).TripLineId,
            };
        },
        watch: {
            getSolveNonDeliveryPostStatus: function (val) {
                if (val === "success") {
                    this.$root.$children[0].$refs.requestToats.makeToast('success', this.$t('SolveNonDeliverySucTitle'), this.$t('SolveNonDeliverySucBody'));
                    this.$store.commit(CLEARSOLVENONDELIVERYSTATUS);
                    this.$router.push("/orderdetails/" + this.$attrs.id);
                }
                if (val === "error") {
                    this.$root.$children[0].$refs.requestToats.makeToast('danger', this.$t('SolveNonDeliveryErrTitle'), this.$t('SolveNonDeliveryErrBody'));
                    this.$store.commit(CLEARSOLVENONDELIVERYSTATUS);
                    this.$router.push("/");
                }
            }
        },
        computed: {
            ...mapGetters(["getNonDeliverySolution", "getSolveNonDeliveryPostStatus", "getnonDeliverySolutionStatus"]),
            loading: function () {
                return this.getnonDeliverySolutionStatus === "loading";
            },
            isRequestSending: function () {
                return this.getSolveNonDeliveryPostStatus === "loading";
            }
        },
        methods: {
            send: function () {
                const data = {
                    reasonId: this.topicId,
                    nonDeliveryId: this.order.NonDelivery
                };

                if (this.isOnline)
                    this.$store.dispatch(SOLVENONDELIVERY_REQUEST, data)
                else
                    this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
            }
        }
    };
</script>

